import * as DATE from 'date-fns';
import { pipe } from 'fp-ts/function';
import * as Str from 'fp-ts/string';

var getCurrentLocale = function getCurrentLocale(lang) {
  return pipe(lang.lastIndexOf('-'), function (index) {
    return index === -1 ? lang : Str.slice(0, index)(lang);
  });
};

export var ignoreQuartersFormatDistance = function ignoreQuartersFormatDistance(a, b, language) {
  return DATE.intlFormatDistance(a, b).includes('quarter') ? DATE.intlFormatDistance(a, b, {
    unit: 'month',
    numeric: 'always',
    locale: getCurrentLocale(language || 'en')
  }) : DATE.intlFormatDistance(a, b, {
    numeric: 'always',
    locale: getCurrentLocale(language || 'en')
  });
};